var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101.333,
    height: 101.336,
    viewBox: "0 0 101.333 101.336",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dashboard",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M51.807,98.953H4.9A4.315,4.315,0,0,1,.586,94.638V82.27L2.566,46.5.586,10.724V4.9A4.315,4.315,0,0,1,4.9.586H51.807A4.315,4.315,0,0,1,56.123,4.9v5.823L54.143,46.5,56.123,82.27V94.638A4.315,4.315,0,0,1,51.807,98.953Z",
    transform: "translate(0.898 0.898)",
    fill: "#6b46cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M29.912,4.9A4.315,4.315,0,0,0,25.6.586H17.68A4.315,4.315,0,0,1,21.995,4.9v5.823L20.016,46.5,21.995,82.27V94.638a4.315,4.315,0,0,1-4.315,4.315H25.6a4.315,4.315,0,0,0,4.315-4.315V82.27L27.933,46.5l1.979-35.773Z",
    transform: "translate(27.109 0.898)",
    fill: "#5f36cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M.586,4.588H56.123V76.134H.586Z",
    transform: "translate(0.898 7.035)",
    fill: "#e1f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M19.383,4.588H27.3V76.134H19.383Z",
    transform: "translate(29.722 7.035)",
    fill: "#ccebff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M20.1,40.11H11.316a2.483,2.483,0,1,1,0-4.965H20.1a2.483,2.483,0,1,1,0,4.965Z",
    transform: "translate(13.545 53.891)",
    fill: "#5ed8f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M43.564,22.739H5.167a1.979,1.979,0,0,1-1.979-1.979V10.151A1.979,1.979,0,0,1,5.167,8.172h38.4a1.979,1.979,0,0,1,1.979,1.979V20.759A1.979,1.979,0,0,1,43.564,22.739Z",
    transform: "translate(4.888 12.531)",
    fill: "#fe75a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M20.339,45.987A14.526,14.526,0,1,0,5.813,31.462,14.526,14.526,0,0,0,20.339,45.987Z",
    transform: "translate(8.914 25.97)",
    fill: "#d0ee7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M13.943,16.936a14.525,14.525,0,0,0-3.958.551,14.524,14.524,0,0,1,0,27.95,14.525,14.525,0,1,0,3.958-28.5Z",
    transform: "translate(15.309 25.97)",
    fill: "#aee617"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M55.631,17.388a5.172,5.172,0,0,0-2.7,5.4,5.168,5.168,0,0,0-8.681,4.548,5.168,5.168,0,0,0-8.488,5.341L25.721,13.518a5.173,5.173,0,0,0-9.164,4.8L30.789,45.486,31,45.88l-8.2-4.318A5.173,5.173,0,1,0,18.349,50.9L40.86,62.039a8.17,8.17,0,0,1,3.707,3.715,8.168,8.168,0,0,0,11.12,3.629l16.178-8.475a8.168,8.168,0,0,0,3.445-11.026,15.95,15.95,0,0,1-1.384-3.692l-.073-.307a73.831,73.831,0,0,0-6.407-17.093L62.614,19.57A5.173,5.173,0,0,0,55.631,17.388Z",
    transform: "translate(23.609 16.477)",
    fill: "#fff1ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M55.612,46.219a15.929,15.929,0,0,1-1.384-3.692l-.073-.307a73.828,73.828,0,0,0-6.407-17.093l-4.831-9.221a5.171,5.171,0,0,0-8.54-.928,5.188,5.188,0,0,1,.623.928l4.831,9.221a73.827,73.827,0,0,1,6.407,17.093l.073.307a15.945,15.945,0,0,0,1.384,3.692A8.168,8.168,0,0,1,44.25,57.245L28.243,65.631a8.158,8.158,0,0,0,7.747.089l16.178-8.476A8.168,8.168,0,0,0,55.612,46.219Z",
    transform: "translate(43.307 20.139)",
    fill: "#ffea80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M23.434,19.4l2.622,5Z",
    transform: "translate(35.932 29.75)",
    fill: "#fff1ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M26.791,17.29l2.989,5.705Z",
    transform: "translate(41.081 26.512)",
    fill: "#fff1ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M30.211,15.5l2.984,5.7Z",
    transform: "translate(46.325 23.765)",
    fill: "#fff1ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M12.127,42.493h8.785c5.093,0,5.1-7.934,0-7.934H12.127C7.034,34.559,7.027,42.493,12.127,42.493Zm0-4.965h8.785a1,1,0,0,1,0,2H12.127A1,1,0,0,1,12.127,37.528Z",
    transform: "translate(12.734 52.993)",
    fill: "#060606"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M23.533,20.406l-9.67,9.671-3.349-3.349a1.485,1.485,0,0,0-2.1,2.1l4.4,4.4a1.485,1.485,0,0,0,2.1,0L25.633,22.5a1.485,1.485,0,0,0-2.1-2.1Z",
    transform: "translate(12.229 30.617)",
    fill: "#060606"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M100.233,65.67A15.572,15.572,0,0,1,98.9,62.015a75.368,75.368,0,0,0-6.536-17.436l-4.831-9.221c-2.735-5.22-10.8-4.352-12.328,1.373a6.72,6.72,0,0,0-8.682,4.548,6.737,6.737,0,0,0-8.022,2.939V5.8a5.807,5.807,0,0,0-5.8-5.8H18.125a1.485,1.485,0,0,0,0,2.969H52.706A2.834,2.834,0,0,1,55.537,5.8v4.338H2.969V5.8A2.834,2.834,0,0,1,5.8,2.969H9.812A1.485,1.485,0,0,0,9.812,0H5.8A5.806,5.806,0,0,0,0,5.8V95.536a5.806,5.806,0,0,0,5.8,5.8H52.706a5.806,5.806,0,0,0,5.8-5.8V77.223l5.3,2.624a6.719,6.719,0,0,1,3.034,3.04,9.754,9.754,0,0,0,13.141,4.289l8.844-4.633a1.485,1.485,0,0,0-1.378-2.63l-8.844,4.633a6.745,6.745,0,0,1-9.1-2.969,9.7,9.7,0,0,0-4.381-4.39L42.616,66.051c-4.228-2.054-1.17-8.686,3.123-6.684l8.173,4.3a1.494,1.494,0,0,0,2.006-2l-14.2-27.1c-2.332-4.383,3.912-8.429,6.294-3.882L58.051,49.84l2.622,5a1.486,1.486,0,0,0,2.63-1.378L60.75,48.595a3.7,3.7,0,0,1,5.955-3.82l2.84,5.421a1.486,1.486,0,0,0,2.63-1.378l-2.888-5.512a3.724,3.724,0,0,1,6.059-3.116L78.2,45.647a1.486,1.486,0,0,0,2.63-1.378l-2.859-5.457c-.389-3.886,5.081-5.611,6.932-2.076l4.831,9.22A72.411,72.411,0,0,1,96.016,62.7,17.673,17.673,0,0,0,97.6,67.047a6.692,6.692,0,0,1-2.819,9.022,1.485,1.485,0,0,0,1.378,2.63,9.663,9.663,0,0,0,4.071-13.029Zm-44.7,29.867a2.834,2.834,0,0,1-2.831,2.831H5.8a2.834,2.834,0,0,1-2.831-2.831V84.653H55.537ZM38.168,59.851a6.707,6.707,0,0,0,.5,6.6,13.04,13.04,0,1,1,3.575-10.108,6.776,6.776,0,0,0-4.076,3.51ZM48.946,27.227a6.65,6.65,0,0,0-2.214-1.186,6.733,6.733,0,0,0-8.5,7.744H10.055a.5.5,0,0,1-.495-.495V22.682a.5.5,0,0,1,.495-.495h38.4a.5.5,0,0,1,.495.495Zm6.591,11.418-3.622-6.913v-9.05a3.468,3.468,0,0,0-3.464-3.464h-38.4a3.468,3.468,0,0,0-3.464,3.464V33.29a3.468,3.468,0,0,0,3.464,3.464h29.46L51.077,58.823l-3.984-2.1L47.04,56.7a6.672,6.672,0,0,0-1.834-.568,16,16,0,1,0-4.357,12.342c4.709,2.714,9.816,4.872,14.688,7.282v5.93H2.969V13.107H55.537Z",
    fill: "#060606"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.a6934df6e76bcc53abc1e15fb4e9e21e.svg";
export { ForwardRef as ReactComponent };